import React, { useState, useEffect } from 'react'
import '../css/Admin/Inventory.css';
import ResponseMsg from '../general/ResponseMsg';
import Camera from '../assets/camera-img.png';
import { useNavigate } from 'react-router-dom';
import Loading from '../general/Loading';

const Inventory = () => {
    const [response, setResponse] = useState();
    const [item, setItem] = useState([]);
    const [showEdit, setShowEdit] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [selectedItem, setSelectedItem] = useState();
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [formData, setFormData] = useState({
        productName: '',
        productUnit: '',
        stock: '',
        barcode: '',
        hsnCode: '',
        category: '',
        mfgDate: '',
        expDate: '',
        // image: null,
        purchasePrice: '',
        originalPrice: '',
        sellPrice: '',
        sellPriceTax: '',
        tax: '',
        discountType: '',
        discountGiven: '',
        description: '',
        prescription: ''
    });
    const [visibleProducts, setVisibleProducts] = useState([]);
    const [batchIndex, setBatchIndex] = useState(0);


    const toggleStock = async (item) => {
        let updatedStockStatus = item.stock === "In Stock" ? "Stock Out" : "In Stock";
        setLoading(true);

        try {
            const response = await fetch(`https://api.kcmstore.in/dist/update-stock/${item.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    stock: updatedStockStatus,
                }),
            });

            const data = await response.json();
            setLoading(false);

            if (response.ok) {
                setResponse('Stock Updated Successfully.');
                setItem(prev =>
                prev.map(p =>
                    p.id === item.id ? { ...p, stock: updatedStockStatus } : p
                )
            );
            setVisibleProducts(prev =>
                prev.map(p =>
                    p.id === item.id ? { ...p, stock: updatedStockStatus } : p
                )
            );
                       setTimeout(() => {
                    setResponse('');
                    // window.location.reload();
                }, 2000);
            } else {
                setLoading(false);
                setResponse('Unable to Update Stock.');
                setTimeout(() => {
                    setResponse('');
                }, 2000);
            }
        } catch (error) {
            setLoading(false);
            console.error("Stock update failed:", error);
        }
    };

    const navigate = useNavigate();
    const [imagePreview, setImagePreview] = useState(null);
    // const fileInputRef = useRef(null);
    // const handleImageClick = () => {
    //     fileInputRef.current.click();
    // };


    useEffect(() => {
        const fetchProducts = async () => {
            setLoading(true);
            try {
                const response = await fetch('https://api.kcmstore.in/dist/get-product');

                if (response.ok) {
                    const data = await response.json();
                    setItem(data);
                    // const formattedData = data.map(item => ({
                    //     ...item,
                    //     mfg: item.mfg ? item.mfg.split(' ')[0] : '',
                    //     exp: item.exp ? item.exp.split(' ')[0] : ''
                    // }));
                    setVisibleProducts(data.slice(0, 100));
                    setBatchIndex(1);
                    setLoading(false);
                } else {
                    setLoading(false);
                    console.error('Failed to fetch users');
                }
            } catch (error) {
                setLoading(false);
                console.error('Error fetching data:', error);
            }
        };

        fetchProducts();
    }, []);


    useEffect(() => {
        if (batchIndex === 0 || item.length === 0) return;

        const interval = setInterval(() => {
            setVisibleProducts((prev) => [
                ...prev,
                ...item.slice(batchIndex * 100, (batchIndex + 1) * 100),
            ]);
            setBatchIndex((prev) => prev + 1);
        }, 2500);

        return () => clearInterval(interval);
    }, [batchIndex, item]);


    const showDeleteItem = (items) => {
        setSelectedItem(items);
        setShowDelete(true);
    }


    const handleDeleteItem = async (productId) => {
        setLoading(true);

        try {
            const response = await fetch(`https://api.kcmstore.in/dist/delete-product/${productId}`, {
                method: 'DELETE',
            });

            setLoading(false);

            if (response.ok) {
                setItem((prevItem) => prevItem.filter((product) => product.id !== productId));
                setResponse('Product deleted successfully!');
                setTimeout(() => {
                    setResponse('');
                }, 2000);
                setShowDelete(false);
            } else {
                setLoading(false);
                setResponse('Unable to Delete product.');
                setTimeout(() => {
                    setResponse('');
                }, 2000);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error deleting product:', error);
        }
    };


    const showEditItem = (items) => {
        setSelectedItem(items);
        setShowEdit(true);
        setImagePreview(items.image != null ? `https://api.kcmstore.in/uploads/${items.image.split(',')[0]}` : Camera);
        setFormData({
            productName: items.name || '',
            productUnit: items.unit || '',
            barcode: items.barcode || '',
            hsnCode: items.hsn_code || '',
            category: items.category || '',
            mfgDate: items.mfg || '',
            expDate: items.exp || '',
            // image: items.image != null ? `https://api.kcmstore.in/uploads/${items.image}` : Camera,
            purchasePrice: items.purchase_price || '',
            originalPrice: items.org_price || '',
            sellPrice: items.sell_price || '',
            sellPriceTax: items.tax_type || 'with tax',
            tax: items.tax_amount || 'none',
            discountType: items.discount_type || '',
            discountGiven: items.discount_amount || '0',
            stock: items.stock_qty,
            description: items.description || '',
            prescription: items.prescription || ''
        });
    }


    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData({
            ...formData,
            [id]: value
        });
    };


    const handleEditItem = async (e) => {
        setLoading(true);
        e.preventDefault();
        try {
            //   const formDataToSend = new FormData();
            //   Object.keys(formData).forEach((key) => {
            //     formDataToSend.append(key, formData[key]);
            //   });

            const response = await fetch(`https://api.kcmstore.in/dist/update-product/${selectedItem.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData),
            });

            setLoading(false);

            if (response.ok) {
                const updatedProduct = await response.json();
                // setProducts((prevProducts) =>
                //   prevProducts.map((product) =>
                //     product.id === selectedProduct.id ? updatedProduct : product
                //   )
                // );
                setResponse('Product updated successfully!');
                setTimeout(() => {
                    setResponse('');
                    setShowEdit(false);
                    window.location.reload();
                }, 1000);
            } else {
                setLoading(false);
                setResponse('Unable to update product.');
                setTimeout(() => {
                    setResponse('');
                }, 2000);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error updating product:', error);
        }
    };

    const filterProduct = visibleProducts.filter(myItem =>
        (myItem.name?.toLowerCase().includes(searchQuery.toLowerCase()) || '')
    );



    return (
        <>
            <section className='px-md-3 px-sm-3 py-3'>
                <div className='profile-area-inner px-lg-4 py-lg-4 px-3 py-3 animate__animated animate__fadeInUp'>
                    <p className='profile-heading'>Inventory</p>

                    <div className='d-flex bg-light rounded-4 py-2'>
                        <i class="fa-solid fa-magnifying-glass text-darkblue py-2 px-3"></i>
                        <input
                            type="text"
                            className="form-input rounded-4 border-0 bg-light w-100"
                            placeholder="Search Products"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>


                    {filterProduct.length > 0 ? (
                        filterProduct.map((items) => (
                            <div className='due-area my-2'>
                                <div className='d-flex justify-content-between'>
                                    {/* <td className='cursor-pointer' onClick={() => navigate(`/product-details/${items.name}`, { state: { items } })}>{items.name}</td> */}

                                    <span className='fw-semibold'>
                                        <span className='cursor-pointer' onClick={() => navigate(`/product-details/${items.name}`, { state: { items } })}>{items.name}</span><br /><br />
                                        <span className='text-danger'>Purchase Price: ₹ {items.purchase_price}</span><br /><span className='text-success'>MRP: ₹ {items.org_price}</span><br />
                                        <span className='text-primary'>Sell Price: {items.sell_price}</span>

                                        {/* <br /><br />
                                            Discount: {items.discount_type == 'amount' ? '₹' : ''} {items.discount_amount} {items.discount_type == 'percent' ? '%' : ''}<br />
                                            Tax: {items.tax_amount} */}
                                    </span>

                                    <div className='text-center'>
                                        <p
                                            className={`due-tag cursor-pointer text-light ${items.stock === 'In Stock' ? "bg-success" : "bg-danger"
                                                }`}
                                            onClick={() => toggleStock(items)}
                                        >
 {items.stock}: {items.stock_qty}                                        </p>
                                        <p className='due-tag cursor-pointer' onClick={() => showEditItem(items)}>View/ Edit</p>
                                        <p className='due-tag cursor-pointer' onClick={() => showDeleteItem(items)}>Remove</p>
                                    </div>
                                </div>


                            </div>
                        ))
                    ) : (
                        <p className='my-3 fw-semibold'>No Products Added Yet.</p>
                    )}

                </div>
            </section>


            {showDelete && (
                <section className='detail-dialog animate__animated animate__zoomIn' onClick={() => setShowDelete(false)}>
                    <div className='detail-dialog-inner col-lg-5 mx-auto px-lg-5 py-lg-5 px-3 py-3 text-center' onClick={(e) => e.stopPropagation()}>

                        <p className='profile-subheading'>Want to remove {selectedItem.name}?</p>

                        <button className='login-btn px-3 py-1' onClick={() => handleDeleteItem(selectedItem.id)}>Yes</button>&nbsp;&nbsp;
                        <button className='login-btn px-3 py-1 bg-danger' onClick={() => setShowDelete(false)}>No</button>

                    </div>
                </section>
            )}


            {showEdit && (
                <section className='detail-dialog' onClick={() => setShowEdit(false)}>
                    <div className='detail-dialog-inner animate__animated animate__zoomIn col-lg-10 mx-auto px-lg-5 py-lg-4 px-3 py-3' onClick={(e) => e.stopPropagation()}>

                        <p className='profile-subheading'>Edit Product</p>


                        <form className="row g-3 bg-white" onSubmit={handleEditItem}>
                            {/* Product Name */}

                            {/* <input
                                type="file"
                                className="profile-input bg-white"
                                id="image"
                                ref={fileInputRef}
                                onChange={handleChange}
                                style={{ display: 'none' }}
                            /> */}
                            <img
                                src={imagePreview}
                                className='inventory-img w-auto mx-auto'
                                alt="product"
                            // onClick={handleImageClick}
                            />

                            <p className='fw-semibold mt-4'>Product Details</p>

                            <div className="col-md-3">
                                <label htmlFor="productName" className="profile-label text-muted">Product Name</label>
                                <input
                                    type="text"
                                    className="profile-input"
                                    id="productName"
                                    value={formData.productName}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Product Unit */}
                            <div className="col-md-3">
                                <label htmlFor="productUnit" className="profile-label text-muted">Product Unit</label>
                                <input
                                    type="text"
                                    className="profile-input"
                                    id="productUnit"
                                    placeholder='Tablets, Capsules, Gel, Supplements...'
                                    value={formData.productUnit}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Category */}
                            <div className="col-md-3">
                                <label htmlFor="category" className="profile-label text-muted">Category</label>
                                <input
                                    type="text"
                                    className="profile-input"
                                    id="category"
                                    placeholder='Fever, Cold, Headache ...'
                                    value={formData.category}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Stock */}
                            <div className="col-md-3">
                                <label htmlFor="stock" className="profile-label text-muted">Stock</label>
                                <input
                                    type="text"
                                    className="profile-input"
                                    id="stock"
                                    value={formData.stock}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Barcode */}
                            <div className="col-md-3">
                                <label htmlFor="barcode" className="profile-label text-muted">Barcode</label>
                                <input
                                    type="text"
                                    className="profile-input"
                                    id="barcode"
                                    value={formData.barcode}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* HSN Code */}
                            <div className="col-md-3">
                                <label htmlFor="hsnCode" className="profile-label text-muted">HSN Code</label>
                                <input
                                    type="text"
                                    className="profile-input"
                                    id="hsnCode"
                                    value={formData.hsnCode}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Manufacturing Date */}
                            <div className="col-md-3">
                                <label htmlFor="mfgDate" className="profile-label text-muted">Mfg Date</label>
                                <input
                                    type="date"
                                    className="profile-input"
                                    id="mfgDate"
                                    value={formData.mfgDate}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Expiry Date */}
                            <div className="col-md-3">
                                <label htmlFor="expDate" className="profile-label text-muted">Exp Date</label>
                                <input
                                    type="date"
                                    className="profile-input"
                                    id="expDate"
                                    value={formData.expDate}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Image Upload */}
                            {/* <div className="col-md-4">
                            <label htmlFor="image" className="profile-label text-muted">Upload Image</label>
                            <input
                                type="file"
                                className="profile-input bg-white"
                                id="image"
                                onChange={handleChange}
                            />
                        </div> */}

                            <p className='fw-semibold mt-4'>Price Details</p>

                            {/* Purchase Price */}
                            <div className="col-md-4">
                                <label htmlFor="purchasePrice" className="profile-label text-muted">Purchase Price</label>
                                <input
                                    type="number"
                                    className="profile-input"
                                    id="purchasePrice"
                                    value={formData.purchasePrice}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Original Price */}
                            <div className="col-md-4">
                                <label htmlFor="originalPrice" className="profile-label text-muted">Original MRP</label>
                                <input
                                    type="number"
                                    className="profile-input"
                                    id="originalPrice"
                                    value={formData.originalPrice}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Sell Price */}
                            <div className="col-md-4">
                                <label htmlFor="sellPrice" className="profile-label text-muted">Sell Price</label>
                                <input
                                    type="number"
                                    className="profile-input"
                                    id="sellPrice"
                                    value={formData.sellPrice}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Sell Price Tax */}
                            <div className="col-md-3">
                                <label className="profile-label text-muted" htmlFor="sellPriceTax">Sell Price Tax</label>
                                <select
                                    className="profile-input"
                                    id="sellPriceTax"
                                    value={formData.sellPriceTax}
                                    onChange={handleChange}
                                >
                                    <option value="with tax" selected>With Tax</option>
                                    <option value="without tax">Without Tax</option>
                                </select>
                            </div>

                            {/* Tax Applicable */}
                            <div className="col-md-3">
                                <label className="profile-label text-muted" htmlFor="tax">Tax Applicable</label>
                                <select
                                    className="profile-input"
                                    id="tax"
                                    value={formData.tax}
                                    onChange={handleChange}
                                    selected
                                >
                                    <option value="none">None</option>
                                    <option value="GST 0">GST 0%</option>
                                    <option value="IGST 0">IGST 0%</option>
                                    <option value="GST 0.25">GST 0.25%</option>
                                    <option value="IGST 0.25">IGST 0.25%</option>
                                    <option value="GST 3">GST 3%</option>
                                    <option value="IGST 3">IGST 3%</option>
                                    <option value="GST 5">GST 5%</option>
                                    <option value="IGST 5">IGST 5%</option>
                                    <option value="GST 12">GST 12%</option>
                                    <option value="IGST 12">IGST 12%</option>
                                    <option value="GST 18">GST 18%</option>
                                    <option value="IGST 18">IGST 18%</option>
                                    <option value="GST 28">GST 28%</option>
                                    <option value="IGST 28">IGST 28%</option>
                                </select>
                            </div>

                            {/* Discount Type */}
                            <div className="col-md-3">
                                <label className="profile-label text-muted" htmlFor="discountType">Sell Price Discount</label>
                                <select
                                    className="profile-input"
                                    id="discountType"
                                    value={formData.discountType}
                                    onChange={handleChange}
                                    selected
                                >
                                    <option value="">Choose...</option>
                                    <option value="percent">Percent %</option>
                                    <option value="amount">Amount ₹</option>
                                </select>
                            </div>

                            {/* Discount Given */}
                            <div className="col-md-3">
                                <label className="profile-label text-muted" htmlFor="discountGiven">Discount Given</label>
                                <input
                                    type="number"
                                    className="profile-input"
                                    id="discountGiven"
                                    value={formData.discountGiven}
                                    onChange={handleChange}
                                />
                            </div>


                            <p className='fw-semibold mt-4'>Related Info</p>

                            {/* Description */}
                            <div className="col-md-4">
                                <label htmlFor="description" className="profile-label text-muted">Description</label>
                                <textarea
                                    className="profile-input"
                                    style={{ height: '9em' }}
                                    id="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Prescription */}
                            <div className="col-md-4">
                                <label htmlFor="prescription" className="profile-label text-muted">Prescription</label>
                                <textarea
                                    className="profile-input"
                                    style={{ height: '9em' }}
                                    id="prescription"
                                    value={formData.prescription}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Submit Button */}
                            <div className="col-12 text-end">
                                <button type="submit" className="login-btn px-3 py-2 bg-danger" onClick={() => setShowEdit(false)}>Close</button>&nbsp;&nbsp;
                                <button type="submit" className="login-btn px-3 py-2">Update</button>
                            </div>
                        </form>

                    </div>
                </section>
            )}


            {loading && <Loading setLoading={setLoading} />}

            {response && <ResponseMsg message={response} />}

        </>
    )
}

export default Inventory
